/**
 * @generated SignedSource<<3850a9e847625650f52d4402d6236e76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockKind = "banner" | "channels" | "collection_folder" | "community_welcome_hero" | "content" | "continue_your_products" | "curriculum" | "experience_details" | "featured_items" | "feed" | "hero" | "leaderboard" | "members_list" | "memberships" | "pathway_sequence" | "product_admin" | "recently_viewed" | "rich_text" | "upcoming_events" | "welcome_banner" | "%future added value";
export type DashboardBlockPosition = "main" | "side" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EditDashboardBlockButtonFragment$data = {
  readonly kind: DashboardBlockKind;
  readonly position: DashboardBlockPosition;
  readonly " $fragmentSpreads": FragmentRefs<"EditDashboardBlockFormFragment">;
  readonly " $fragmentType": "EditDashboardBlockButtonFragment";
};
export type EditDashboardBlockButtonFragment$key = {
  readonly " $data"?: EditDashboardBlockButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditDashboardBlockButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditDashboardBlockButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditDashboardBlockFormFragment"
    }
  ],
  "type": "DashboardBlock",
  "abstractKey": "__isDashboardBlock"
};

(node as any).hash = "66ee58059dfaf7c33fd7a623ecdd8eb2";

export default node;
